import React, { CSSProperties, FunctionComponent, ImgHTMLAttributes } from 'react';
import { CheckButton, CheckLabel, CheckSubText, CheckText } from './CheckItem.style';

interface Props {
  ariaLabel?: string;
  containerStyle?: CSSProperties;
  label: string;
  subLabel?: string;
  checked: boolean;
  icon?: ImgHTMLAttributes<any>;
  onValueChange: (value: boolean) => void;
  testID?: string;
}

const CheckItem: FunctionComponent<Props> = (props) => {
  return (
    <CheckButton
      aria-label={props.ariaLabel}
      $checked={props.checked}
      style={props.containerStyle}
      onClick={() => props.onValueChange(!props.checked)}
      role="checkbox"
      type="button"
      aria-checked={props.checked}
      data-testid={props.testID}
    >
      {props.icon && <img {...props.icon} alt="icon" />}

      <CheckLabel>
        <CheckText style={{ textAlign: props.icon ? 'left' : undefined }}>{props.label}</CheckText>

        {props.subLabel && <CheckSubText>{props.subLabel}</CheckSubText>}
      </CheckLabel>
    </CheckButton>
  );
};

export default React.memo(CheckItem);
